import { render, staticRenderFns } from "./data_permission.vue?vue&type=template&id=7eddbc87&scoped=true&"
import script from "./data_permission.vue?vue&type=script&lang=js&"
export * from "./data_permission.vue?vue&type=script&lang=js&"
import style0 from "./data_permission.vue?vue&type=style&index=0&id=7eddbc87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eddbc87",
  null
  
)

export default component.exports